export default __webpack_public_path__ + "static/media/logo.8a75b809.png";